export default {
  "b2b.projekty-grid-columns.nazev.label": "Název",
  "b2b.projekty-grid-columns.popis.label": "Popis",
  "b2b.projekty-grid-columns.smlouva.label": "Smlouva",
  "b2b.projekty-grid-columns.vytvoril.label": "Vytvořil",
  "b2b.projekty-grid-columns.upravil.label": "Upravil",
  "b2b.projekty-grid-columns.datumUprava.label": "Datum úpravy",
  "b2b.projekty-grid-columns.datumVytvoreni.label": "Datum vytvoření"
};
